import { render, staticRenderFns } from "./No22.vue?vue&type=template&id=29b69660&scoped=true"
import script from "./No22.vue?vue&type=script&lang=js"
export * from "./No22.vue?vue&type=script&lang=js"
import style0 from "./No22.vue?vue&type=style&index=0&id=29b69660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b69660",
  null
  
)

export default component.exports